import { ITableRowProps } from "../../../oversight-core/interfaces/table-row-props";
import styles from "./site-table-row.module.scss";

const SitesTableRow = (props: ITableRowProps) => {
  const { data, cellWidths = [] } = props;
  return (
    <>
      {data.map((item, index) => {
        const isFirst = index === 0;
        const isLast = index === data.length - 1;

        const classNames = [
          styles["row-cell"],
          isFirst && styles["first-cell"],
          isLast && styles["last-cell"],
        ]
          .filter(Boolean)
          .join(" ");

        const widthStyle = cellWidths[index]
          ? {
              width:
                typeof cellWidths[index] === "number"
                  ? `${cellWidths[index]}px`
                  : cellWidths[index],
              minWidth: "100%",
            }
          : { minWidth: "100%" };

        return (
          <div className={`${classNames} h-100`} style={widthStyle} key={index}>
            {item}
          </div>
        );
      })}
    </>
  );
};

export default SitesTableRow;
